import store from '@store'
export default {
  path: '/invoicepreparation',
  component: () => import('@views/InvoicePreparation/Index'),
  children: [
    {
      path: 'index/:id',
      name: 'invoicepreparation.index',
      component: () => import('@/components/InvoicePreparation/InvoicePreparation'),
      beforeEnter: (to, from, next) => {
        store.dispatch('GET_INVOICE_HEADER', null)
        store.dispatch('GET_INVOICE_ITEMS', null)
        next()
      }
    }
  ]
}
